class GuestUserController {
  constructor($scope,$uibModalInstance, optionsModal) {
    this.$uibModalInstance = $uibModalInstance;
    this.$scope = $scope;
    this.optionsModal = optionsModal;
  }


  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  selectThird() {
    if(this.guestUserForm.$valid){
      this.$uibModalInstance.close(this.user);
    } else {
      this.guestUserForm.contactoNombre.$setDirty();
      this.guestUserForm.contactoEmail.$setDirty();
      this.guestUserForm.contactoTelefono.$setDirty();
      this.guestUserForm.contactoDireccion.$setDirty();
      this.guestUserForm.contactoNombreCiudad.$setDirty();
    }
  }
}

GuestUserController.$inject = ['$scope', '$uibModalInstance', 'optionsModal'];

export default GuestUserController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/cart/modal-logistic/modal-logistic.controller.js
 **/